import _DatabaseModel from "./_DatabaseModel";

const ASSET_GROUP_TAB_ASSETS = 182;

class AssetGroup extends _DatabaseModel {
  static model = "asset_group";
  static showSize = 8;
  static editDialogComponent = "asset-groups-edit-dialog";
  static tableHeaders = [{ textKey: "form.label.name", value: "name" }];
  static createNewObject = {
    object: {},
    params: {},
  };

  static show = {
    buttons: ["edit"],
    reloadingModels: ["asset"],
  };

  static filter = {
    parts: {
      fields: ["name", "time_filter"],
      extended_fields: [],
      time_filter: ["created_at", "updated_at"],
    },
  };

  static basicInfo(object) {
    return [
      {
        labelKey: "form.label.created_at",
        value: object.created_at,
        type: "date_time",
      },
      {
        labelKey: "form.label.updated_at",
        value: object.updated_at,
        type: "date_time",
      },
    ];
  }

  static submenuActions = [
    this.commonActions.openActivities,
    this.commonActions.delete,
  ];

  static tabs = [
    this.detailTab,
    {
      titleKey: "asset.assets",
      permission: ASSET_GROUP_TAB_ASSETS,
      component: "AssetsOnAssetGroupTab",
      disabled: this.defaultDisabledTab(),
    },
  ];
}

export default AssetGroup;
